import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { auth } from '../firebase';
import Signup from './modals/Signup'

import { Button } from 'reactstrap';

import texts from '../data/texts';

class Nav extends Component {

  render() {
    const { path } = this.props;

    return (
      <div id="navbarContainer" className="container-fluid">
        <div className="container px-0">
          <nav className="navbar navbar-expand-sm px-0">
            <div>
              <Link to='/' className="navbar-brand"><img src='/imgs/paul_logo_color_small.svg' alt="Paul Open Search Logo" style={{width: 40, height: 40}}/></Link>
            </div>

            <button className="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
              <i className="fas fa-bars text-secondary"></i>
            </button>


            <div className="ml-auto text-right collapse navbar-collapse text-center text-md-right" id="navbarSupportedContent">
              <ul className="navbar-nav ml-auto">
                {
                  path!=='/' &&
                  <li className="nav-item px-md-3">
                    <Link to='/' className='nav-link'>Start</Link>
                  </li>
                }
                <li className="nav-item px-md-3">
                  <Link to='/about' className='nav-link'>Über uns</Link>
                </li>
                <li className="nav-item px-md-3">
                  <Signup className="mb-4 mb-md-0 shadow-sm"/>
                </li>
              </ul>
            </div>

          </nav>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (state, props) => ({
  path: props.location.pathname
});

export default withRouter(connect(mapStateToProps)(Nav));



// WEBPACK FOOTER //
// ./src/components/Nav.js